import { GPL } from './BulkGuestPass';
import { connect } from 'react-redux';
const mapStateToProps = (state) => ({
  companies: state.companyReducer.companies,
  users: state.userReducer.users
});
const GPL2 = connect(mapStateToProps, null)(GPL);
export default GPL2;
